class CampaignExamples {
  constructor() {
    this.classes = this.sectionClasses;
    this.selectors = this.sectionSelectors;
    this.debug = false;
    this.intersectionObserver = null;
    this.isDesktop = window.innerWidth > 1023;
  }

  get sectionClasses() {
    return {
      section: 'js-campaign-examples',
      video: 'js-campaign-video',
      trigger: 'js-video-change-trigger',
      videoIndex: 'data-video-index',
      videoType: 'data-video-type',
      triggerIndex: 'data-trigger-index',
      active: 'active',
    };
  }

  get sectionSelectors() {
    return {
      sections: document.querySelectorAll(`.${this.sectionClasses.section}`),
    };
  }

  init() {
    this.setupIntersectionObserver();
    this.setupVideoTriggers();
    this.handleResize();
    this.adjustVideoPositions();
  }

  adjustVideoPositions() {
    const sections = this.selectors.sections;

    sections.forEach((section) => {
      const videoDivs = section.querySelectorAll(`.${this.classes.video}`);
      const sectionRect = section.getBoundingClientRect();

      videoDivs.forEach((videoDiv) => {
        const videoRect = videoDiv.getBoundingClientRect();

        // Check if video overflows the section
        if (videoRect.bottom > sectionRect.bottom) {
          // Video overflows, set to bottom-0
          videoDiv.classList.remove('lg:top-0');
          videoDiv.classList.add('lg:bottom-0');
        } else {
          // Video fits, set to top-0
          videoDiv.classList.remove('lg:bottom-0');
          videoDiv.classList.add('lg:top-0');
        }
      });
    });
  }

  setupIntersectionObserver() {
    // Create intersection observer for video elements
    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;

          if (entry.isIntersecting) {
            // Video is in viewport
            if (video.classList.contains(this.classes.video)) {
              // For js-campaign-video div, check if it has active attribute and play the video inside
              if (video.hasAttribute(this.classes.active)) {
                const videoElement = video.querySelector('video');
                const imgElement = video.querySelector('img');
                
                if (videoElement) {
                  videoElement.play().catch((error) => {
                    if (this.debug) console.log('Video play error:', error);
                  });
                } else if (imgElement) {
                  // Images don't need special handling for play/pause
                }
              }
            } else {
              // For regular video elements, play if in viewport
              video.play().catch((error) => {
                if (this.debug) console.log('Video play error:', error);
              });
            }
          } else {
            // Video is not in viewport, pause it
            if (video.classList.contains(this.classes.video)) {
              // For js-campaign-video div, pause the video inside
              const videoElement = video.querySelector('video');
              if (videoElement) {
                videoElement.pause();
              }
            } else {
              // For regular video elements, pause
              video.pause();
            }
          }
        });
      },
      {
        threshold: 0.1, // Trigger when 10% of video is visible
        rootMargin: '0px',
      }
    );

    // Observe all video elements and js-campaign-media divs
    const allVideos = document.querySelectorAll('video');
    const campaignVideoDivs = document.querySelectorAll(`.${this.classes.video}`);

    allVideos.forEach((video) => {
      this.intersectionObserver.observe(video);
    });

    campaignVideoDivs.forEach((div) => {
      this.intersectionObserver.observe(div);
    });
  }

  setupVideoTriggers() {
    if (!this.isDesktop) return;

    const sections = this.selectors.sections;

    sections.forEach((section) => {
      const triggers = section.querySelectorAll(`.${this.classes.trigger}`);
      const videoDivs = section.querySelectorAll(`.${this.classes.video}`);

      triggers.forEach((trigger) => {
        const triggerIndex = trigger.getAttribute(this.classes.triggerIndex);

        // Mouse enter - add active attribute to corresponding video div
        trigger.addEventListener('mouseenter', () => {
          if (this.debug) console.log('Mouse enter on trigger:', triggerIndex);
          videoDivs.forEach((videoDiv) => {
            const videoIndex = videoDiv.getAttribute(this.classes.videoIndex);
            if (videoIndex === triggerIndex) {
              videoDiv.setAttribute(this.classes.active, '');
              if (this.debug) console.log('Set active on video div:', videoIndex);

              // Always try to play video on hover, regardless of viewport
              const videoElement = videoDiv.querySelector('video');
              const imgElement = videoDiv.querySelector('img');
              
              if (videoElement) {
                videoElement.play().catch((error) => {
                  if (this.debug) console.log('Video play error:', error);
                });
              } else if (imgElement) {
                // if (this.debug) console.log('Image is now active');
              }
            } else {
              videoDiv.removeAttribute(this.classes.active);
              const videoElement = videoDiv.querySelector('video');
              if (videoElement) {
                videoElement.pause();
              }
            }
          });
        });

        // Mouse leave - stop all videos and remove active attribute
        trigger.addEventListener('mouseleave', () => {
          videoDivs.forEach((videoDiv) => {
            videoDiv.removeAttribute(this.classes.active);
            const videoElement = videoDiv.querySelector('video');
            if (videoElement) {
              videoElement.pause();
            }
          });
        });
      });
    });
  }

  isElementInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  handleResize() {
    window.addEventListener('resize', () => {
      const wasDesktop = this.isDesktop;
      this.isDesktop = window.innerWidth > 1023;

      // If switching between desktop and mobile, reinitialize triggers
      if (wasDesktop !== this.isDesktop) {
        this.setupVideoTriggers();
      }

      // Recalculate video positions on resize
      this.adjustVideoPositions();
    });
  }

  destroy() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }
}

export default CampaignExamples;
